import { Trans } from '@lingui/react/macro';
import { Breadcrumb, Breadcrumbs } from '@pocketlaw/tetris';
import { Link, Route, Switch } from 'react-router-dom';
export function UserTeamBreadcrumbs(props) {
    const { baseUrl } = props;
    return (<Breadcrumbs>
      <Breadcrumb as={Link} to={baseUrl}>
        <Trans comment="users & teams route - users & teams tab">Users &amp; teams</Trans>
      </Breadcrumb>
      <Switch>
        <Route path={`${baseUrl}/users`}>
          <Breadcrumb as={Link} to={`${baseUrl}/users`}>
            <Trans comment="users & teams route - users tab">Users</Trans>
          </Breadcrumb>
        </Route>
        <Route path={`${baseUrl}/invites`}>
          <Breadcrumb as={Link} to={`${baseUrl}/invites`}>
            <Trans comment="users & teams route - pending invites tab">Pending invites</Trans>
          </Breadcrumb>
        </Route>
        <Route path={`${baseUrl}/teams`}>
          <Breadcrumb as={Link} to={`${baseUrl}/teams`}>
            <Trans comment="users & teams route - teams tab">Teams</Trans>
          </Breadcrumb>
          <Switch>
            <Route path={`${baseUrl}/teams/:teamId`}>
              <Breadcrumb>
                <Trans comment="Team profile breadcrumb">Team profile</Trans>
              </Breadcrumb>
            </Route>
          </Switch>
        </Route>
      </Switch>
    </Breadcrumbs>);
}
